import Component from './ViewDefaultPopupFormSignup.vue';
export default Component;



// WEBPACK FOOTER //
// ./src/pages/default/popup/forms/signup/index.js